import { ReactComponent as IntegratedCareIcon } from "../img/My-health/icon_integratedcare.svg";
import { ReactComponent as PrescriptionIcon } from "../img/My-health/icon_presciption.svg";
import { ReactComponent as TestReportsIcon } from "../img/My-health/icon_testreports.svg";
import { ReactComponent as DietIcon } from "../img/My-health/icon_diet.svg";
import { ReactComponent as PhysioIcon } from "../img/My-health/icon_physio.svg";
import { ReactComponent as PainScoreIcon } from "../img/My-health/icon_painscore.svg";
import { ReactComponent as HealthInfoIcon } from "../img/My-health/icon_healthinfo.svg";
// import { ReactComponent as ChatDoctorIcon } from "../img/icons/icon_chat_doctor.svg";
import { Link, useHistory } from "react-router-dom";
import BottomNav from "../components/bottomNav";
import SideNav from "../components/sideNav";
import { useTranslation } from "react-i18next";
import createPersistedState from "use-persisted-state";
import { InsertChart } from "@material-ui/icons";

const useIsChatButtonEnabledState = createPersistedState("isChatButtonEnabled");

function MyClinicPage({}) {
  const history = useHistory();
  const { t } = useTranslation();

  const [isChatButtonEnabled, setIsChatButtonEnabled] =
    useIsChatButtonEnabledState();

  return (
    <>
      <SideNav />
      <div className="body_content py-4">
        <div className="inner_body ">
          <div className="w-100 mb-2 integrated_block d-flex align-items-center justify-content-center">
            <div className="icon me-3">
              <IntegratedCareIcon className="img-fluid" />
            </div>
            <span className="txt_name">{t("MYHEALTH.care")}</span>
          </div>
          <span className="coming_soon d-flex align-items-center justify-content-center">
            {t("appointment.MYCLINIC.coming")}
          </span>
          <ul className="list-unstyled list_dashboard mt-4">
            <li>
              <a onClick={() => history.push("/prescriptions")}>
                <span className="icon">
                  <PrescriptionIcon className="img-fluid" />
                </span>
                <span className="txt">{t("MYHEALTH.prescription")}</span>
              </a>
            </li>
            <li>
              <a onClick={() => history.push("/my-reports")}>
                <span className="icon">
                  <TestReportsIcon className="img-fluid" />
                </span>
                <span className="txt">{t("MYHEALTH.reports")}</span>
              </a>
            </li>
            <li>
              <Link to="/diet">
                <span className="icon">
                  <DietIcon className="img-fluid" />
                </span>
                <span className="txt">{t("MYHEALTH.diet")}</span>
              </Link>
            </li>
            <li>
              <Link to="#">
                <span className="icon">
                  <PhysioIcon className="img-fluid" />
                </span>
                <span className="txt">{t("MYHEALTH.physio")}</span>
                <span className="coming_soon">
                  {t("appointment.MYCLINIC.coming")}
                </span>
              </Link>
            </li>
            <li>
              <Link to="/pain-score">
                <span className="icon">
                  <PainScoreIcon className="img-fluid" />
                </span>
                <span className="txt">{t("MYHEALTH.pain")}</span>
              </Link>
            </li>
            <li>
              <a onClick={() => history.push("/my-health-info")}>
                <span className="icon">
                  <HealthInfoIcon className="img-fluid" />
                </span>
                <span className="txt">{t("MYHEALTH.info")}</span>
              </a>
            </li>
            <li>
              <a onClick={() => history.push("/score-chart")}>
                <span className="icon">
                  <InsertChart
                    style={{ fontSize: "48px", color: "#f6781b" }}
                    fontSize="large"
                    className="img-fluid"
                  />
                </span>
                <span className="txt">{t("MYHEALTH.chart")}</span>
              </a>
            </li>
          </ul>
          <BottomNav
            option="my-health"
            isChatButtonEnabled={isChatButtonEnabled}
          />
        </div>
        {/* <Link to="/chat">
        
          <ChatDoctorIcon
            style={{ position: "fixed", right: "5px", bottom: "80px" }}
          />
        </Link> */}
      </div>
    </>
  );
}

export default MyClinicPage;
